import React from 'react';
import {t} from 'lib/i18n';

/**
 * 되감기/빨리감기 컴포넌트
 */

interface ISkip {
  onClickRewind: () => void;
  onClickForward: () => void;
}

const Skip = ({onClickRewind, onClickForward}: ISkip) => {
  return (
    <>
      <button
        type='button'
        className='btn_rewind'
        aria-label={t('되감기')}
        onClick={onClickRewind}></button>
      <button
        type='button'
        className='btn_forward'
        aria-label={t('빨리감기')}
        onClick={onClickForward}></button>
    </>
  );
};

export default Skip;
